"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRemoveDocument;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _context2 = require("../../context");

/*
  Delete Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useRemoveDocument() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useRemoveDocument`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var removeDocument = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.removeDocument({
                  path: path
                }).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function removeDocument(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [removeDocument, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useRemoveDocument/useRemoveDocument.js
// module id = 1838
// module chunks = 0